export default "__VITE_ASSET__B4JJZ0i___"